import _debounce from 'lodash/debounce';
import { getBreakpoint, horizontalResizeEvent } from './_utils';

export default function simpleList() {
	const setMinHeight = ($ul, $target) => {
		if ($target.length > 0) {
			const minHeightValue = $target.position().top + $target.outerHeight();
			$ul.css('max-height', minHeightValue);
		} else {
			$ul.removeAttr('style').removeClass('is-expanded');
		}
	};

	const handleOpen = $ul => {
		const $target = $ul.find('li').last();
		setMinHeight($ul, $target);

		if ($ul.data('track-interactions')) {
			window.FS.Tealium.trackInteraction(
				'action',
				'view all',
				$ul.parents('.SimpleList').find('.Heading-title').text().trim() || 'expandable list'
			);
		}
	};

	const handleClose = $ul => {
		const $target =
			getBreakpoint() === 'small'
				? $ul.find('.is-hintedSmall').last()
				: $ul.find('.is-hintedMedium').last();

		setMinHeight($ul, $target);
	};

	const init = () => {
		$('.SimpleList-list--truncated').each((index, element) => {
			const $element = $(element);
			const $toggle = $element.next('.SimpleList-toggle');

			$element.parents('.SimpleList').first().addClass('SimpleList--js');
			$element.removeAttr('style').removeClass('is-expanded');
			$toggle.removeClass('is-expanded');

			handleClose($element);

			$toggle.off('click.simpleList');
			$toggle.on('click.simpleList', event => {
				if ($element.hasClass('is-expanded')) {
					handleClose($element);
				} else {
					handleOpen($element);
				}

				$element.toggleClass('is-expanded');
				$toggle.toggleClass('is-expanded');
			});
		});
	};

	$(window).on(`${horizontalResizeEvent}`, _debounce(init, 25));
	init();
}
